var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperPlaneRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "svg2038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path2036",
    style: {
      fill: "#143964",
      fillOpacity: 1
    },
    d: "m 481.32422,0.02539063 c -5.9,-0.24999975 -11.87462,1.12383117 -17.22461,4.17382817 L 16.099609,260.19922 C -6.500368,273.09921 -4.4007572,307.50001 19.699219,317.5 L 160,376 V 479.30078 C 160,497.40076 174.59924,512 192.69922,512 c 9.69999,0 18.90157,-4.30079 25.10156,-11.80078 l 62,-74.29883 L 403.69922,477.5 c 18.89998,7.89999 40.80039,-4.49924 43.90039,-24.69922 l 64,-415.999999 c 1.9,-12.099988 -3.40001,-24.301179 -13.5,-31.2011716 -5.05,-3.4499966 -10.8754,-5.32421903 -16.77539,-5.57421877 z M 409.69922,90.599609 C 336.29686,172.43937 263.21311,254.56517 189.75781,336.35742 L 68.199219,285.69922 Z m 41.10156,26.000001 -47.5,308.80078 -166.60156,-69.5 z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneRegular);
export default __webpack_public_path__ + "static/media/paper-plane-regular.1273874dd31a3c00bed82933a404a3f3.svg";
export { ForwardRef as ReactComponent };